
import { formatPriceRP } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import { Vue, Options, prop } from "vue-class-component";
import ModalV3 from "@/app/ui/components/modal/modal-v3.vue";

class Props {
  modelValue = prop<boolean>({
    required: true,
    default: false,
    type: Boolean
  });
  error = prop<string>({
    default: "",
    required: true
  });
  balance = prop<string>({
    default: ""
  });
  price = prop<string>({
    default: ""
  });
}

@Options({
  emits: [
    "update:modelValue",
    "reload",
    "scrollToDestination",
    "scrollToCod",
    "scrollToCommodity"
  ],
  components: {
    ModalV3
  }
})
class ModalFailedBookingV4 extends Vue.with(Props) {
  get messageEntities() {
    return new ModalMessageEntities({
      customWidth: "380px",
      image: this.errorData.image,
      imageWidth: "32",
      imageHeight: "32",
      title: this.$t("bookingV3.modalFailed.title"),
      customTitleMessagePadding: "px-8 py-2.5"
    });
  }

  get isAccountForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  get isErrorBalance() {
    return (
      this.error === "ERROR_POS_NOT_ENOUGH_BALANCE" ||
      this.error === "ERROR_POS_UNDER_LIMIT_BALANCE"
    );
  }

  formatPriceRP(price: any) {
    return formatPriceRP(Number(price), this.isAccountForeign ? "MYR" : "IDR");
  }

  get errorData() {
    const image = () => {
      const obj = {
        SYSTEM: "error-token-ngen",
        ERROR_EMBARGO: "ill_spot_embargo",
        ERROR_ACCOUNT_INACTIVE: "ill_badge_profile_block_user",
        ERROR_CHECK_TARIFF: "ill_badge_tariff_not_available",
        ERROR_CLIENT_IS_BANNED: "badge-warning-lg",
        ERROR_COD_NOT_ALLOWED: "badge-warning-lg",
        ERROR_COMMODITY_NOT_FOUND: "badge-warning-lg",
        ERROR_COMMODITY_INACTIVE: "badge-warning-lg",
        ERROR_PARTNER_IS_BANNED: "ill_toko_unavailable",
        ERROR_POS_NOT_ENOUGH_BALANCE: "badge-warning-lg",
        ERROR_POS_UNDER_LIMIT_BALANCE: "badge-warning-lg",
        ERROR_CP_PIECE_BALANCE_EXHAUSTED: "badge-warning-lg",
        ERROR_CP_PIECE_BALANCE_NOT_AVAILABLE: "badge-warning-lg",
        ERROR_CP_PIECE_BALANCE_INSUFFICIENT: "badge-warning-lg",
        "Stt tidak bisa dibooking. Mohon cek apakah client atau destinasi yang dipilih memperbolehkan layanan DFOD":
          "badge-warning-lg",
        "Stt cannot be booked. Please check is client or the destination allowed for DFOD services":
          "badge-warning-lg",
        "": "error-internet"
      } as any;
      return obj[this.error] ?? "badge-warning-lg";
    };

    const reason = () => {
      const obj = {
        SYSTEM: this.$t("bookingV3.modalFailed.reason.system"),
        ERROR_EMBARGO: this.$t("bookingV3.modalFailed.reason.embargo"),
        ERROR_ACCOUNT_INACTIVE: this.$t(
          "bookingV3.modalFailed.reason.inactive"
        ),
        ERROR_CHECK_TARIFF: this.$t("bookingV3.modalFailed.reason.tariff"),
        ERROR_CLIENT_IS_BANNED: this.$t(
          "bookingV3.modalFailed.reason.clientFreeze"
        ),
        ERROR_COD_NOT_ALLOWED: this.$t(
          "bookingV3.modalFailed.reason.codUnavailable"
        ),
        ERROR_COMMODITY_NOT_FOUND: this.$t(
          "bookingV3.modalFailed.reason.commodity"
        ),
        ERROR_COMMODITY_INACTIVE: this.$t(
          "bookingV3.modalFailed.reason.commodity"
        ),
        ERROR_PARTNER_IS_BANNED: this.$t(
          "bookingV3.modalFailed.reason.posFreeze"
        ),
        ERROR_POS_NOT_ENOUGH_BALANCE: this.$t(
          "bookingV3.modalFailed.reason.balance"
        ),
        ERROR_POS_UNDER_LIMIT_BALANCE: this.$t(
          "bookingV3.modalFailed.reason.balanceNegative"
        ),
        ERROR_CP_PIECE_BALANCE_EXHAUSTED: this.$t(
          "bookingV3.modalFailed.reason.pieceBalance"
        ),
        ERROR_CP_PIECE_BALANCE_NOT_AVAILABLE: this.$t(
          "bookingV3.modalFailed.reason.pieceBalanceAvailable"
        ),
        ERROR_CP_PIECE_BALANCE_INSUFFICIENT: this.$t(
          "bookingV3.modalFailed.reason.pieceBalanceInfucient"
        ),
        "Stt tidak bisa dibooking. Mohon cek apakah client atau destinasi yang dipilih memperbolehkan layanan DFOD": this
          .error,
        "Stt tidak bisa dibooking. Mohon cek apakah client atau destinasi yang dipilih memperbolehkan layanan COD": this
          .error,
        "Stt cannot be booked. Please check is client or the destination allowed for DFOD services": this
          .error,
        "Stt cannot be booked. Please check is client or the destination allowed for COD services": this
          .error,
        "": this.$t("bookingV3.modalFailed.reason.connection")
      } as any;
      return obj[this.error] ?? this.error;
    };

    const title = () => {
      const obj = {
        SYSTEM: this.$t("bookingV3.modalFailed.button.reload"),
        ERROR_EMBARGO: this.$t("bookingV3.modalFailed.button.back"),
        ERROR_ACCOUNT_INACTIVE: this.$t(
          "bookingV3.modalFailed.button.understand"
        ),
        ERROR_CHECK_TARIFF: this.$t(
          "bookingV3.modalFailed.button.changeDestinationProduct"
        ),
        ERROR_CLIENT_IS_BANNED: this.$t(
          "bookingV3.modalFailed.button.understand"
        ),
        ERROR_COD_NOT_ALLOWED: this.$t(
          "bookingV3.modalFailed.button.chooseOther"
        ),
        ERROR_COMMODITY_NOT_FOUND: this.$t(
          "bookingV3.modalFailed.button.changeCommodity"
        ),
        ERROR_COMMODITY_INACTIVE: this.$t(
          "bookingV3.modalFailed.button.changeCommodity"
        ),
        ERROR_PARTNER_IS_BANNED: this.$t(
          "bookingV3.modalFailed.button.understand"
        ),
        ERROR_POS_NOT_ENOUGH_BALANCE: this.$t(
          "bookingV3.modalFailed.button.topUp"
        ),
        ERROR_POS_UNDER_LIMIT_BALANCE: this.$t(
          "bookingV3.modalFailed.button.topUp"
        ),
        ERROR_CP_PIECE_BALANCE_EXHAUSTED: this.$t(
          "bookingV3.modalFailed.button.understand"
        ),
        ERROR_CP_PIECE_BALANCE_NOT_AVAILABLE: this.$t(
          "bookingV3.modalFailed.button.understand"
        ),
        ERROR_CP_PIECE_BALANCE_INSUFFICIENT: this.$t(
          "bookingV3.modalFailed.button.understand"
        ),
        "Stt tidak bisa dibooking. Mohon cek apakah client atau destinasi yang dipilih memperbolehkan layanan DFOD": this.$t(
          "bookingV3.modalFailed.button.understand"
        ),
        "Stt cannot be booked. Please check is client or the destination allowed for DFOD services": this.$t(
          "bookingV3.modalFailed.button.understand"
        ),
        "": this.$t("bookingV3.modalFailed.button.reload")
      } as any;
      return (
        obj[this.error] ?? this.$t("bookingV3.modalFailed.button.understand")
      );
    };
    return {
      image: image(),
      reason: reason(),
      title: title()
    };
  }

  onClickButton() {
    const onClick = {
      SYSTEM: () => {
        this.$emit("reload");
        this.$emit("update:modelValue", false);
      },
      ERROR_EMBARGO: () => {
        this.$emit("update:modelValue", false);
      },
      ERROR_ACCOUNT_INACTIVE: () => {
        this.$emit("reload");
        this.$emit("update:modelValue", false);
      },
      ERROR_CHECK_TARIFF: () => {
        this.$emit("scrollToDestination");
        this.$emit("update:modelValue", false);
      },
      ERROR_CLIENT_IS_BANNED: () => {
        this.$emit("update:modelValue", false);
      },
      ERROR_COD_NOT_ALLOWED: () => {
        this.$emit("scrollToCod");
        this.$emit("update:modelValue", false);
      },
      ERROR_COMMODITY_NOT_FOUND: () => {
        this.$emit("scrollToCommodity");
        this.$emit("update:modelValue", false);
      },
      ERROR_COMMODITY_INACTIVE: () => {
        this.$emit("scrollToCommodity");
        this.$emit("update:modelValue", false);
      },
      ERROR_PARTNER_IS_BANNED: () => {
        this.$emit("update:modelValue", false);
      },
      ERROR_POS_NOT_ENOUGH_BALANCE: () => {
        window.open("/balance/balance-mutation-nett", "_blank");
        this.$emit("update:modelValue", false);
        this.$emit("topup");
      },
      ERROR_POS_UNDER_LIMIT_BALANCE: () => {
        window.open("/balance/balance-mutation-nett", "_blank");
        this.$emit("update:modelValue", false);
        this.$emit("topup");
      },
      ERROR_CP_PIECE_BALANCE_EXHAUSTED: () => {
        this.$emit("update:modelValue", false);
      },
      "": () => this.$emit("reload")
    } as any;
    const handler =
      onClick[this.error] ?? (() => this.$emit("update:modelValue", false));
    handler();
  }
}

export default ModalFailedBookingV4;
